import { Toaster as Sonner, toast } from "sonner"

// Notificações no estilo Diavice: grafite, faixa de cor à esquerda conforme o tipo
const Toaster = ({ ...props }) => (
  <Sonner
    theme="dark"
    className="toaster group"
    toastOptions={{
      classNames: {
        toast: "group toast font-sans !rounded-md !border-l-4 !border-l-blue-500 !shadow-xl !shadow-black/40",
        title: "!font-semibold !text-slate-50",
        description: "!text-slate-400",
        success: "!border-l-emerald-500",
        error: "!border-l-red-500",
        warning: "!border-l-amber-400",
        info: "!border-l-blue-500",
        icon: "group-data-[type=success]:!text-emerald-400 group-data-[type=error]:!text-red-400 group-data-[type=warning]:!text-amber-300 group-data-[type=info]:!text-blue-300",
        actionButton: "!bg-blue-500 !text-white",
        cancelButton: "!bg-slate-800 !text-slate-300",
      },
    }}
    {...props}
  />
)

export { Toaster, toast }
